export const PREBOOK_EXIT_ROUTES = [
  '/',
  '/blog/[slug]',
  '/crop/[id]/problem/[problemId]',
  '/ondc'
]
